import React from 'react';
import { ContentBox, ContentsLayout, Main, Meta } from '@layout';

import Image from 'next/image';
import { LinkBox } from '@components';
import { Fade } from 'react-awesome-reveal';

const contents = {
  title1: '입점안내',
  title2: '세금포인트몰 입점절차',
  contentsHeaderTitle: '세금포인트 할인쇼핑몰 입점절차',
  contentsHeaderDesc: `세금포인트 할인쇼핑몰과 함께라면 신규 판로개척이 가능합니다.`,
  border: true,
};

const linkBox = {
  text: '보다 자세한 사항은 판판대로를 참고하세요.',
  iconLabel: '판판대로 바로가기',
};

const Index = () => {
  return (
    <Main
      meta={
        <Meta
          title="입점절차 | 세금포인트 할인쇼핑몰"
          description="세금포인트 할인쇼핑몰 입점절차"
          canonical="https://www.taxpoint.or.kr"
        />
      }
    >
      <ContentsLayout contents={contents}>
        <div className="flex flex-col">
          <Fade cascade triggerOnce>
            <ContentBox title="절차안내">
              <li className="laptop:flex hidden items-center">
                <Image
                  src={`/about/about.jpg`}
                  alt="세금포인트몰"
                  width="817"
                  height="176"
                />
              </li>
              <li className="block laptop:hidden">
                <Image
                  src={`/about/about_mobile.jpg`}
                  alt="세금포인트몰"
                  width="720"
                  height="176"
                />
              </li>
            </ContentBox>
            <ContentBox title="판판대로 접속 및 입점신청">
              <li><a style={{ color : '#0065be', cursor : 'pointer'}} href="https://www.fanfandaero.kr" target='_blank' rel='noopener noreferrer'>판판대로(https://www.fanfandaero.kr)</a> 회원가입</li>
              <li>동반성장몰 입점을 위한 서류 준비</li>
              <li>동반성장몰 입점신청 및 서류 제출</li>
            </ContentBox>
            <ContentBox title="서류평가 및 상품선정 위원회 진행">
              <li>입점 신청 시 제출 서류 평가</li>
              <li>상품선정위원회 심사를 통해 상품 시장성 및 적합성 검토</li>
              <li>여성기업, 장애인기업 등 각종 사회적 기업 가점 부여</li>
            </ContentBox>
            <ContentBox title="전자계약 체결 및 상품등록">
              <li>입점 허가된 업체와 전자계약 체결</li>
              <li>통합상품코드 발급</li>
              <li>동반성장몰 & 세금포인트 할인쇼핑몰 내 상품 등록</li>
              <li>MD의 상품승인 후 상품노출</li>
            </ContentBox>
            <ContentBox title="타 온라인채널 진출">
              <li>
                동반성장몰 & 세금포인트 할인쇼핑몰 우수 판매업체, 온라인 판로확대 희망 업체 대상 타
                온라인 채널 진출 지원
              </li>
              - 타 온라인 채널 : LG 임직원몰, 현대아이파크몰 등
            </ContentBox>
          </Fade>
          <LinkBox linkBox={linkBox} />
        </div>
      </ContentsLayout>
    </Main>
  );
};

export default Index;
